<template>
  <div class="common-layout">
    <el-container>
      <el-header style="margin: 0;padding: 0;width: 100%;height: auto">
        <!--        轮播图-->
        <el-carousel :interval="5000" arrow="always" :height="'33vh'">
          <el-carousel-item v-for="item in pictureContent" :key="item">
            <el-image style="width: 100%; height: 100%" :src="item.address" :fit="'cover'"/>
          </el-carousel-item>
        </el-carousel>

      </el-header>

      <el-main style="margin: 0;padding: 0;width: 100%;;background-color: rgb(245,245,245);">
        <div class="body-layout">
          <!--          <el-container>-->
          <!--            <el-header style="margin-top: 4.5%;">-->
          <div style="width: auto">
            <el-row style="margin-top: 7.3vh;width: auto;">
              <el-button type="primary"
                         style="background-color: rgb(0,97,214);width: 19.3vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zyzc.sczyzx.cn/')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="car" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">采购人入口</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgb(0,97,214);width: 19vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://dyzcpt.sczyzx.cn/api/account/login?systemid=7bfc9d76-612f-4db9-af78-cdfcd68162de&areaid=510600&returnurl=https://zyzc.sczyzx.cn/pub/ulify/loginCallback')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="people" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">供应商入口</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgb(0,97,214);width: 20vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zypqd.sczyzx.cn/#/')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="zuanshi" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">评标专家入口</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgb(0,97,214);width: 20vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zyzc.sczyzx.cn/#/')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="hua" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">中介代理机构入口</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>
            </el-row>

            <el-row style="margin-top: 0.5vh;width: auto;">
              <el-button type="primary"
                         style="background-color: rgba(0,67,148);width: 19.3vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zyzc.sczyzx.cn/')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="car" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">采购人注册</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgba(0,67,148);width: 19vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zyzcsso.sczyzx.cn/UserLogin/UserRegister/Index')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="people" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">供应商注册</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgba(0,67,148);width: 20vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://zyzc.sczyzx.cn/')">
                <el-image style="width: 2.4vw; height: 4vh;margin-left: -2vh" :src="eye" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">监督人入口</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>

              <el-button type="primary"
                         style="background-color: rgba(0,67,148);width: 20vw;height: 8.5vh;border: 0"
                         @click="buttonClick('https://www.dyggzy.com/downFile')">
                <el-image style="width: 2.4vw; height: 4vh;" :src="down" :fit="'scale-down'"/>
                <span style="font-size: 1.2vw;margin-left: 0.75vw">CA证书驱动下载</span>
                <el-image style="width: 1.2vw; height: 2.4vh;margin-left: 1vw" :src="leave" :fit="'cover'"/>
              </el-button>
            </el-row>
          </div>


          <!--  重要通知-->
          <el-card style="width: 80vw;margin-top: 2.3vh">
            <div style="display: flex;justify-content: center;align-items: center;">
              <div style="display: flex;justify-content: center;align-items: center;width: 45%">
                <el-image :src="SVA" :fit="'scale-down'"/>
              </div>
              <div style="width: 55%;height: 40vh">
                <div class="card-header">
                  <span style="font-size: 0.9vw;font-weight: bold;margin-left: 1.5vw">重要通知</span>
                  <span style="float: right;margin-right: 2vw;cursor: pointer;font-size: 0.8vw" @click="consultTomore">更多></span>
                  <el-divider/>
                </div>
                <el-row class="font-background" v-for="item in newsList" :key="item"
                        style="height: 5vh; align-items: center;margin-left: 1.5vw" @click="newsClick(item.id)">
                  <el-col style="cursor: pointer;font-size: 0.85vw">
                    <span style="">{{ item.title }}</span>
                    <span style="float: right;margin-right: 2vw">{{ item.createTime }}</span>
                  </el-col>
                </el-row>
                <el-row class="font-background" v-for="item in newsContent" :key="item"
                        style="height: 5vh; align-items: center;margin-left: 1.5vw" @click="redirectToLink(item.link)">
                  <el-col style="cursor: pointer;font-size: 0.85vw">
                    <span style="">{{ item.title }}</span>
                    <span style="float: right;margin-right: 2vw">{{ item.createTime }}</span>
                  </el-col>
                </el-row>
              </div>

            </div>
          </el-card>

          <el-card style="width: 80vw;margin-top: 2.3vh;height: 16vh;display: flex;justify-content: center;">

            <div style="width: 80vw">
              <el-row style="margin-top: 2vh">
                <el-col>
                  <el-row style="display: flex">
                    <el-col :span="24/numList.length" v-for="item in numList" :key="item.id">
                      <div style="display: flex;align-items: center;justify-content: center">
                        <el-image :src="imageUrl + item.filePath" :fit="'scale-down'" style="width: 2.8vw;height: 5vh"/>
<!--                        <span style="font-size: 1.3vw;font-weight: bolder;color: #ec6a64">{{ item.quantity }}</span>-->
<!--                        <span style="color: #ec6a64;font-size: 0.8vw">{{ item.unit }}</span>-->
                      </div>
                      <div style="display: flex;align-items: center;justify-content: center">
                        <span style="font-size: 1.3vw;font-weight: bolder;color: #ec6a64">{{ item.quantity }}</span>
                        <span style="color: #000000;font-size: 0.8vw">{{ item.unit }}</span>
                      </div>
                      <div style="display: flex;align-items: center;justify-content: center;margin-top: 1vh">
                        <span style="font-size: 0.9vw">{{ item.title }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

          </el-card>

          <!--   采购公告  -->
          <el-card style="width: 80vw;margin-top: 2.3vh">
            <!--                <template #header>-->
            <div class="card-header">
                    <span
                        style="width: 0.1vw; background-color: rgb(0,67,148); height: 1.6vh; margin-right: 0.5vw; display: inline-block;margin-top: 2vh;margin-left: 0.5vw"></span>
              <span style="font-size: 0.9vw;font-weight: bold">招标公告</span>
              <span @click="notice_tomore"
                    style="display: block;float: right;font-size: 0.8vw;margin-top: 1.6vh;margin-right:0.5vw;cursor: pointer;">更多></span>
            </div>

            <div style="margin-top: 0.6vh;margin-bottom: 2vh">
              <el-tabs v-model="bidding" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane label="采购公告" name="toBidding" style="min-height: 50vh">
                  <el-row class="font-background" v-for="item in toBidding" :key="item.content"
                          style="height: 5.5vh;margin-left: 1vw"
                          @click="rowClick(bidding,item.noticeName,item.noticeCreateTime)">
                    <el-col style="cursor: pointer; font-size: 0.9vw; display: flex; align-items: center;">
                      <span
                          style="display: inline-block; margin-left: 1vw;max-width: 55em;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"> {{
                          item.noticeName
                        }} </span>
                      <span style="display: inline-block; margin-left: auto;margin-right: 5vw;"
                            class="time_color"> {{ item.noticeCreateTime.substring(0,10) }} </span>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane label="澄清公告" name="clarification" style="min-height: 50vh">
                  <el-row class="font-background" v-for="item in clarification" :key="item.content"
                          style="height: 5.5vh;margin-left: 1vw"
                          @click="rowClick(bidding,item.noticeName,item.noticeCreateTime)">
                    <el-col style="cursor: pointer; font-size: 0.9vw; display: flex; align-items: center;">
                      <span
                          style="display: inline-block; margin-left: 1vw;max-width: 55em;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"> {{
                          item.noticeName
                        }} </span>
                      <span style="display: inline-block; margin-left: auto;margin-right: 5vw;"
                            class="time_color"> {{ item.noticeCreateTime.substring(0,10) }} </span>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane label="中标候选人公示" name="readyBidding" style="min-height: 50vh">
                  <el-row class="font-background" v-for="item in readyBidding" :key="item.content"
                          style="height: 5.5vh;margin-left:1vw"
                          @click="rowClick(bidding,item.noticeName,item.noticeCreateTime)">
                    <el-col style="cursor: pointer; font-size: 0.9vw; display: flex; align-items: center;">
                      <!--                      <div style="width: 2.5vw; height: 3.3vh; display: inline-block; line-height: 5.5vh;"></div>-->
                      <span
                          style="display: inline-block; margin-left: 1vw;max-width: 55em;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"> {{
                          item.noticeName
                        }} </span>
                      <span style="display: inline-block; margin-left: auto;margin-right: 5vw;"
                            class="time_color"> {{ item.noticeCreateTime.substring(0,10) }} </span>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane label="中标结果公告" name="resultBidding" style="min-height: 50vh">
                  <el-row class="font-background" v-for="item in resultBidding" :key="item.content"
                          style="height: 5.5vh;margin-left: 1vw"
                          @click="rowClick(bidding,item.noticeName,item.noticeCreateTime)">
                    <el-col style="cursor: pointer; font-size: 0.9vw; display: flex; align-items: center;">
                      <!--                      <div style="width: 2.5vw; height: 3.3vh; display: inline-block; line-height: 5.5vh;"></div>-->
                      <span
                          style="display: inline-block; margin-left: 1vw;max-width: 55em;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"> {{
                          item.noticeName
                        }} </span>
                      <span style="display: inline-block; margin-left: auto;margin-right: 5vw;"
                            class="time_color"> {{ item.noticeCreateTime.substring(0,10) }} </span>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <!--  友情连接-->
          <el-card style="width: 80vw;margin-top: 2.3vh;height: auto" class="friend-card">
            <div style="width: auto;height: auto">
              <span
                  style="width: 0.1vw; background-color: rgb(0,67,148); height: 1.6vh; margin-right: 0.5vw; display: inline-block;margin-top: 2vh;margin-left: 0.5vw"></span>
              <span style="font-size: 0.9vw;font-weight: bold">友情链接</span>
            </div>
            <div style="margin-top: 1vh;display: flex;font-size: 0.9vw;width: auto;height: auto">
              <div class="friendLink"
                   style="width: 12vw;height: 7vh;display: flex;align-items: center;justify-content: center;cursor: pointer"
                   @click="buttonClick('https://www.dyggzy.com/tradingIndex?type=JYSSGQY&name=%E5%9B%BD%E4%BC%81%E8%87%AA%E8%90%A5')">
                公共资源交易中心德阳站
              </div>
              <div class="friendLink"
                   style="width: 10vw;height: 7vh;display: flex;align-items: center;justify-content: center;cursor: pointer"
                   @click="buttonClick('https://www.dyggzy.com/tradingIndex?type=JYSSGQY&name=%E5%9B%BD%E4%BC%81%E8%87%AA%E8%90%A5')">
                德阳发展集团
              </div>
              <div class="friendLink"
                   style="width: 13vw;height: 7vh;display: flex;align-items: center;justify-content: center;cursor: pointer"
                   @click="buttonClick('http://cxbxdy.com/')">
                长信保险经纪(北京)有限公司
              </div>
              <div class="friendLink"
                   style="width: 15vw;height: 7vh;display: flex;align-items: center;justify-content: center;cursor: pointer"
                   @click="buttonClick('https://sczyzx.cn/#/home')">
                四川卓远企业征信咨询有限公司
              </div>
              <div class="friendLink"
                   style="width: 11vw;height: 7vh;display: flex;align-items: center;justify-content: center;cursor: pointer"
                   @click="buttonClick('https://cx.sczyzx.cn/gw/#/home')">
                德阳光大拍卖有限公司
              </div>
            </div>
          </el-card>

          <div style="height: 4vh"></div>
        </div>
      </el-main>

      <div
          style="position: fixed;bottom: 8vh;right: 3vw;background-color: rgb(243,249,255);border-radius: 1vh;color: rgb(0,67,148)">

        <div style="margin-top: 1vh;display: flex;align-items: center;justify-content: center;">
          <el-popover
              placement="left-start"
              trigger="hover"
              width="9vw"
          >
            <template #reference>
              <!--              <el-image :src="qr_code" :fit="'scale-down'" style="width: 4vw;height: 5vh"/>-->
              <div style="font-size: 0.8vw;border-radius: 1vh;cursor: pointer"
                   @click="buttonClick('https://zbznkf.sczyzx.cn/#/')">
                <div style="display: flex;justify-content: center;align-items: center">
                  <el-image :src="service" :fit="'scale-down'" style="width: 2vw;height: 4vh"/>
                </div>
                <div style="display: flex;justify-content: center;align-items: center">
                  <span>智能客服</span>
                </div>
              </div>
            </template>
            <el-image :src="QRcode" :fit="'scale-down'" style="height: 11vh;width: 8vw;cursor: pointer"
                      @click="buttonClick('https://zbznkf.sczyzx.cn/#/')"/>
          </el-popover>
        </div>
        <el-divider />
        <div style="margin-top: 1vh;display: flex;align-items: center;justify-content: center;">
          <el-popover
              placement="left-start"
              trigger="hover"
              width="9vw"
          >
            <template #reference>
              <!--              <el-image :src="wechat" :fit="'scale-down'" style="width: 4vw;height: 5vh"/>-->
              <div style="font-size: 0.8vw;border-radius: 1vh">
                <div style="display: flex;justify-content: center;align-items: center">
                  <el-image :src="chat" :fit="'scale-down'" style="width: 2vw;height: 4vh"/>
                </div>
                <div style="display: flex;justify-content: center;align-items: center">
                  <span>企业微信</span>
                </div>
              </div>
            </template>
            <el-image :src="CompanyVchat" :fit="'scale-down'" style="height: 11vh;width: 8vw"/>
          </el-popover>
        </div>
        <el-divider />
        <div style="margin-top: 1vh;display: flex;align-items: center;justify-content: center;">
          <el-popover
              placement="left-start"
              trigger="hover"
              width="12vw"
          >
            <template #reference>
              <!--              <el-image :src="phone" :fit="'scale-down'" style="width: 4vw;height: 5vh"/>-->
              <div style="font-size: 0.8vw;border-radius: 1vh">
                <div style="display: flex;justify-content: center;align-items: center">
                  <el-image :src="phone" :fit="'scale-down'" style="width: 2vw;height: 4vh"/>
                </div>
                <div style="display: flex;justify-content: center;align-items: center">
                  <span>联系电话</span>
                </div>
              </div>
            </template>
            <div>
              <el-row>
                <el-col>
                  <span>系统操作：0838-2909997</span>
                </el-col>
                <el-col>
                  <span>CA问题：0838-2516653(德阳)</span>
                </el-col>
                <el-col>
                  <span>CA问题：028-85593299(成都)</span>
                </el-col>
              </el-row>
            </div>
          </el-popover>
        </div>
        <el-divider />
        <div style="margin-top: 1vh;display: flex;align-items: center;justify-content: center;cursor: pointer" @click="gotoOpinion">

          <div style="font-size: 0.8vw;border-radius: 1vh">
            <div style="display: flex;justify-content: center;align-items: center">
              <el-image :src="opinionCollection" :fit="'scale-down'" style="width: 2vw;height: 4vh"/>
            </div>
            <div style="display: flex;justify-content: center;align-items: center">
              <span>意见征集</span>
            </div>
          </div>
        </div>
        <el-divider />

        <div style="margin-top: 1vh;margin-bottom:1vh;display: flex;align-items: center;justify-content: center;cursor: pointer" @click="buttonClick('http://tbbt.sczyzx.cn:8080/dist/#/')">
          <el-popover
              placement="left-start"
              trigger="hover"
              width="9vw"
          >
            <template #reference>
              <!--              <el-image :src="report" :fit="'scale-down'" style="width: 4vw;height: 5vh"/>-->
              <div style="font-size: 0.8vw;border-radius: 1vh">
                <div style="display: flex;justify-content: center;align-items: center">
                  <el-image :src="supervision" :fit="'scale-down'" style="width: 2vw;height: 4vh"/>
                </div>
                <div style="display: flex;justify-content: center;align-items: center">
                  <span>监督举报</span>
                </div>
              </div>
            </template>
            <el-image :src="tousu" :fit="'scale-down'" style="height: 11vh;width: 8vw;cursor: pointer"
                      @click="buttonClick('http://tbbt.sczyzx.cn:8080/dist/#/')"/>
          </el-popover>
        </div>

      </div>

    </el-container>
  </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import car from '@/assets/home/car.png'
import leave from '@/assets/home/leave.png'

import SVA from '@/assets/home/dySVA.jpg'
import router from "@/router";
import efficient from '@/assets/marquee/4e3630d2ba58e8b3f3955e7825b2ba2.jpg'
import original from '@/assets/marquee/99a2af07654b71b94f431d0331454b7.jpg'
import sun from '@/assets/marquee/06a7a7645173bccd788cc47b5b25ae6.jpg'
import {getToBiddingMessage} from "@/api/toBidding";
import {getClarificationMessage} from "@/api/clarification";
import {getReadyBiddingMessage} from "@/api/readyBidding";
import {getResultBiddingMessage} from "@/api/result";

import service from '@/assets/home/service.png'
import chat from '@/assets/home/weChat.png'
import people from '@/assets/home/people.png'
import zuanshi from '@/assets/home/zuanshi.png'
import hua from '@/assets/home/hua.png'
import eye from '@/assets/home/eye.png'
import down from '@/assets/home/down.png'
import supervision from '@/assets/home/supervision.png'
import QRcode from '@/assets/mainvue/QRcode.jpg'
import CompanyVchat from '@/assets/mainvue/CompanyVchat.png'
import tousu from '@/assets/mainvue/tousu.png'
import phone from '@/assets/home/phone.png'
import opinionCollection from '@/assets/home/opinionCollection.png'
import {getNewsLsit, getNumDetial} from "@/api/serverJs";

// 控制是否显示右下方的弹窗
let show = ref(true)
// 轮播图列表
let pictureContent = [
  {
    address: efficient
  },
  {
    address: original
  },
  {
    address: sun
  }
]

const splitDate = (dateTime)=>{
  return dateTime.split
}
// new从后台返回的数据
let newsList = ref([])
// news内容
let newsContent = ref([
  {
    title: '招投标文件制作工具',
    createTime: '2024-01-26 09:06:40',
    link: 'https://zbznkf.sczyzx.cn/upload/documents/招投标文件制作工具.zip'
  },
  {
    title: '用户操作手册',
    createTime: '2024-01-26 09:06:40',
    link: 'https://gzzc.sczyzx.cn/'
  },
  {
    title: '线下办理CA',
    createTime: '2024-01-26 09:06:40',
    link: 'https://gzzc.sczyzx.cn/'
  }
])

// let newsContent = ref([
//   {
//     title: '中华人民共和国招标投标法',
//     time: '2018/01/04',
//     link: 'http://www.npc.gov.cn/zgrdw/npc/xinwen/2018-01/04/content_2036284.htm'
//   },
//   {
//     title: '中华人民共和国政府采购法',
//     time: '2015/01/30',
//     link: 'https://www.gov.cn/'
//   },
//   {
//     title: '中华人民共和国招标投标实施条例',
//     time: '2011/12/20',
//     link: 'https://www.gov.cn/'
//   },
//   {
//     title: '中华人民共和国政府采购法实施条例',
//     time: '2002/06/29',
//     link: 'https://www.gov.cn/'
//   }
// ])

// 采购公告
let toBidding = ref([])
// 澄清公告
let clarification = ref([])
// 中标候选人公示
let readyBidding = ref([])
// 中标结果公告
let resultBidding = ref([])


const newsClick = (id) => {
  localStorage.setItem('id', id)
  router.push('/news')
}

// nes内容点击跳转方法
const redirectToLink = (link) => {
  window.open(link, '_blank');
}
// 招标采购 点击更多跳转到招标采购页面
const notice_tomore = () => {
  router.push({path: '/Notice'})
}

const consultTomore = () => {
  router.push({path: '/consult'})
}
// 采购项目、
let numList = ref([])
// 招标采购卡片中 头部导航栏
let bidding = ref('toBidding')

const imageUrl = ref('http://43.137.46.89:8888')

const handleClick = (tab) => {
  if (tab.props.name === 'toBidding') {
    getToBidding()
  }
  if (tab.props.name === 'clarification') {
    getClarification()
  }
  if (tab.props.name === 'readyBidding') {
    getReadyBidding()
  }
  if (tab.props.name === 'resultBidding') {
    getResultBidding()
  }
}

const rowClick = (kind, name, time) => {
  localStorage.setItem('kind', kind)
  localStorage.setItem('name', name)
  localStorage.setItem('time', time)
  router.push('/detail')
}

const buttonClick = (url) => {
  window.open(url)
}


onMounted(() => {
  getToBidding()
  getNum()
  getNews()
})

let news = ref({
  'title': '',
  'author': '',
  'currentPage': 1,
  'pageSize': 4
})

let detialVo = ref({
  'currentPage': 0,
  'pageSize': 0
})

// 获取新闻列表
const getNews = () => {
  getNewsLsit(news).then(res => {
    res.data.data.list.forEach(newsItem => {
      newsList.value.push(newsItem)
    })
    newsList = newsList.value.slice(0,4)
  })
}

// 获取后台首页详情数据
const getNum = () => {
  getNumDetial(detialVo).then(res => {
    res.data.data.forEach(num => {
      numList.value.push(num)
    })
  })
}

// 采购公告
const getToBidding = () => {
  getToBiddingMessage(0, 10).then(res => {
    toBidding.value = res.data.result.list
  })
}


// 澄清公告
const getClarification = () => {
  getClarificationMessage(0, 10).then(res => {
    clarification.value = res.data.result.list
  })
}

// 中标候选人公示
const getReadyBidding = () => {
  getReadyBiddingMessage(0, 10).then(res => {
    readyBidding.value = res.data.result.list
  })
}

// 中标结果公告
const getResultBidding = () => {
  getResultBiddingMessage(0, 10).then(res => {
    resultBidding.value = res.data.result.list
  })
}

const gotoOpinion = () => {
  router.push('/opinion')
}

</script>

<style scoped>
.common-layout {
  width: 100%;
  height: auto;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 30vh;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.body-layout {
  margin-left: 10vw;
  width: auto;
}

.time_color {
  color: rgb(153, 153, 153)
}

/** 取消.el-tabs的默认下划线 **/
:deep(.el-tabs__nav-wrap::after) {
  height: 0;
}

/** 设置默认字体颜色 **/
:deep(.el-tabs__item) {
  width: 9vw;
  font-size: 0.8vw;
  color: rgba(99, 99, 99, 0.72);
  opacity: 0.9;
}

/** 触碰时字体效果颜色 **/
:deep(.el-tabs__item:hover) {
  color: rgb(99, 99, 99);
  cursor: pointer;
  opacity: 1;
}

/* 选中时字体颜色 */
:deep(.el-tabs__item.is-active) {
  color: rgb(0, 67, 148);
  font-size: 0.9vw;
  opacity: 1;
}

/* 选中时下划线颜色 */
:deep(.el-tabs__active-bar) {
  background-color: rgb(0, 67, 148);
  height: 0.2vh;
  width: 7.65vw;
}

.font-background:hover {
  color: rgba(0, 67, 148, 0.85);
  background-color: rgb(235, 235, 235);
}

.button-container {
  width: 64.2vw;
  display: flex;
  flex-wrap: wrap;
  grid-row-gap: 0.8vh;
  grid-column-gap: 0.4vw
}

.button-container > button {
  background-color: white;
  color: black;
  cursor: pointer;
  border: 0.1vh solid #eae7e7; /* 添加 0.1vh 黑色边框 */
}

.button-container > button:hover {
  animation: colorChange 1s ease infinite;
}

@keyframes colorChange {
  0% {
    background-color: rgba(236, 76, 67, 0.33);
    color: white;
  }
  50% {
    background-color: rgba(255, 0, 0, 0.66);
    color: white;
  }
  100% {
    background-color: rgb(236, 76, 67);
    color: white;
    border: 0.1vh solid #8a8686;
  }
}

.friendLink:hover {
  background-color: rgb(237, 237, 237);
}

.el-card {
  --el-card-padding: 0 !important;
}


.el-button + .el-button {
  margin-left: 0.6vw !important;
}

.el-tabs {
  --el-tabs-header-height: 4vh !important;
}

:deep(.el-divider--horizontal) {
  border-top: 0.1vh var(--el-border-color) var(--el-border-style);
  display: block;
  height: 0.1vh;
  margin: 1.2vh 0;
  width: 100%;
}

.el-card {
  --el-card-border-radius: 0.4vh !important;
  border: 0.1vh solid var(--el-card-border-color) !important;
}

</style>
